<template>
  <div class="app-container">
    <div class="filter-container">
      <el-input class="filter-item" v-model="listQuery.querymodel.keyword" placeholder="路段名称" style="width: 200px"
        @keyup.enter.native="getList()" />
      <toolbar :buttonList="buttonList" @callFunction="callFunction"></toolbar>
      <div class="filter-item" v-if="ProductId == 2">
        <el-button type="info" plain @click="downstorecode()">车辆注册二维码下载</el-button>
      </div>
    </div>
    <el-table class="app-table" :data="list" border fit highlight-current-row stripe style="width: 100%"
      :height="getViewHeight()" :header-cell-style="{
        background: '#F3F4F7',
        color: '#555',
        align: 'center',
      }" :row-style="{ height: '10px' }" :cell-style="{ padding: '7px 0' }">
      <el-table-column :key="i" v-for="(col, i) in columns" :label="col.label" :align="col.align" :prop="col.value"
        :type="col.type" :width="col.width" header-align="center">
      </el-table-column>
      <el-table-column label="路段二维码" align="center">
        <template slot-scope="{ row }">
          <div v-if="row.SectionCode" class="newCode" :id="'qrcode_' + row.SectionCode"
            @click="createCode(row.SectionCode, true, row.SectionName, row)">
            <canvas :id="'canvas_' + row.SectionCode" v-if="row.SectionCode"></canvas>
          </div>
          <div v-else @click="getCode(row)" class="getCode">获取路段二维码</div>
        </template>
      </el-table-column>
      <el-table-column label="操作" align="center" :min-width="190">
        <template slot-scope="{ row }">
          <el-button type="primary" size="mini" icon="el-icon-edit" v-if="authedit" @click="edit(row)">
            编辑
          </el-button>
          <el-button v-if="authdelete" icon="el-icon-delete" size="mini" type="danger" @click="deleted(row)">
            删除
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <pagination v-show="total > 0" :total="total" :page.sync="listQuery.pageIndex" :limit.sync="listQuery.pageSize"
      @pagination="getList" />
    <el-dialog :title="codeTitle" :visible.sync="codeShow" show-close width="350px" class-name="vertical-center-modal">
      <div class="codeModal" id="qrcode">
        <canvas id="canvas"></canvas>
      </div>
      <div class="codeBtns">
        <div @click="downCode">下载二维码</div>
      </div>
    </el-dialog>
    <addsection v-if="dialogshow" :dialogshow="dialogshow" :isedit="isedit" :editform="editform"
      @savecomplete="savecomplete" @cancelcomplete="cancelcomplete"></addsection>
  </div>
</template>
<style scoped>
.getCode {
  color: #398af1;
  cursor: pointer;
}

.newCode {
  align-self: center;
  /*width: 30px;*/
  /*height: 50px;*/
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  cursor: pointer;
}

.codeModal {
  width: 100%;
  height: auto;
  display: flex;
  align-items: center;
  justify-content: center;
}

.codeBtns {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-around;
  color: #398af1;
  font-size: 15px;
  margin-bottom: 20px;
}

.codeBtns>div {
  cursor: pointer;
}

.codeBtns>div:hover {
  opacity: 0.8;
}
</style>
<script>
import { query, deleted, gettablecode } from "@/api/section";
import waves from "@/directive/waves"; // waves directive
import { getButtonList } from "../../promissionRouter";
import Pagination from "@/components/Pagination"; // secondary package based on el-pagination
import Toolbar from "../../components/Toolbar";
import Addsection from "./components/addsection.vue";
import QRCode from "qrcode";
export default {
  components: { Pagination, Toolbar, Addsection, QRCode },
  directives: { waves },
  data() {
    return {
      ProductId: 1,
      codeTitle: "",
      batchdialogshow: false,
      codeShow: false,
      codeInfo: {},
      dialogshow: false,
      dialogshow: false,
      isedit: false,
      buttonList: [],
      isedit: false,
      authedit: false,
      authdelete: false,
      editform: {},
      downloadLoading: false,
      list: null,
      pageIndex: 1,
      total: 0,
      columns: [
        {
          label: "序号",
          value: "index",
          align: "center",
          type: "index",
          width: 100,
        },
        { label: "路段名称", value: "SectionName", align: "center", type: "" },
        { label: "服务电话", value: "ServicePhone", align: "center" },
        { label: "创建时间", value: "CreateTime", align: "center" },
      ],
      listQuery: {
        pageIndex: 1,
        pageSize: 15,
        orderColumn: "",
        orderbyasc: false,
        querymodel: {
          keyword: "",
        },
      },
    };
  },
  created() {
    this.ProductId = window.localStorage.ProductId;
    this.getList();
  },
  methods: {
    callFunction(item) {
      this[item.BtnCode].apply(this, item);
    },
    create() {
      this.isedit = false;
      this.dialogshow = true;
    },
    edit(row) {
      this.editform = row;
      this.isedit = true;
      this.dialogshow = true;
    },
    savecomplete(item) {
      this.dialogshow = false;
      this.getList();
    },
    cancelcomplete() {
      this.dialogshow = false;
    },
    deleted(row) {
      this.$confirm("确定删除吗?", "提示", {
        type: "warning",
      }).then(() => {
        deleted({ id: row.Id }).then((res) => {
          this.$message({
            message: "删除成功！",
            type: "success",
          });
          this.getList();
        });
      });
    },
    getList(item) {
      if (item != null && item != undefined) {
        this.listQuery.pageIndex = item.page;
        this.listQuery.pageSize = item.limit;
      } else {
        this.listQuery.pageIndex = 1;
      }
      query(this.listQuery).then((res) => {
        this.list = res.data;
        this.total = res.dataCount;
        setTimeout(() => {
          this.list.forEach((item) => {
            if (item.SectionCode) {
              this.createCode(item.SectionCode);
            }
          });
        }, 300);
      });
    },
    createCode(SectionCode, show, name, row) {
      if (!show) {
        var canvas = document.getElementById("canvas_" + SectionCode);
        QRCode.toCanvas(canvas, SectionCode, { width: 50 }, function (error) {
          if (error) console.error(error);
        });
      } else {
        this.codeInfo = row;
        this.codeInfo.SectionCode = SectionCode;
        this.codeTitle = `${name}的路段码`;
        this.codeShow = show;
        setTimeout(() => {
          var canvas = document.getElementById("canvas");
          QRCode.toCanvas(
            canvas,
            SectionCode,
            { width: 300 },
            function (error) {
              if (error) console.error(error);
            }
          );
        }, 100);
      }
    },
    createCode2(SectionCode, show, name, row) {
      if (!show) {
        var canvas = document.getElementById("canvas_" + SectionCode);
        QRCode.toCanvas(canvas, SectionCode, { width: 50 }, function (error) {
          if (error) console.error(error);
        });
      } else {
        this.codeInfo = row;
        this.codeInfo.SectionCode = SectionCode;
        this.codeTitle = `${name}`;
        this.codeShow = show;
        setTimeout(() => {
          var canvas = document.getElementById("canvas");
          QRCode.toCanvas(
            canvas,
            SectionCode,
            { width: 300 },
            function (error) {
              if (error) console.error(error);
            }
          );
        }, 100);
      }
    },
    refCode(id) {
      gettablecode({ id: this.codeInfo.Id || id }).then((res) => {
        this.createCode(res, true, this.codeInfo.TableName, this.codeInfo);
        // setTimeout(() => {
        //   this.createCode(res);
        // }, 1000);
      });
    },
    downstorecode() {
      let storecode = "https://tc.mtfpos.com?z=" + window.localStorage.storecode;
      this.createCode2(storecode, true, "车辆注册二维码", {});
    },
    downCode() {
      var canvas = document.getElementById("canvas");
      var a = document.createElement("a");
      a.href = canvas.toDataURL();
      a.download = `${this.codeTitle}`;
      a.click();
    },
  },
  mounted() {
    let routers = window.localStorage.router
      ? JSON.parse(window.localStorage.router)
      : [];
    this.buttonList = getButtonList(this.$route.path, routers);
    this.buttonList.forEach((item) => {
      if (item.BtnCode === "delete") {
        this.authdelete = true;
      }
      if (item.BtnCode === "edit") {
        this.authedit = true;
      }
    });
  },
};
</script>
